import { useTheme } from "@mui/material/styles";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useState } from "react";
import qrcode from "../../assets/QRCODE01.png";

const ReservationSelectComponent = ({ data, value, label, setValue, type }) => {
  const theme = useTheme();
  const [expandedId, setExpandedId] = useState(null);

  const handleMenuItemClick = (item, type) => {
    if (type === "ticket" || type === "activity") {
      if (expandedId === item.id) {
        // If accordion is closing, select the item
        setValue(item);
        setExpandedId(null);
      } else {
        // Open accordion
        setExpandedId(item.id);
      }
    } else {
      setValue(item);
    }
  };

  return (
    <>
      {data.map((item) => (
        <Box
          key={item.id}
          value={item?.resType}
          sx={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            alignItems: "start",
            background: item?.id === value?.id ? "#EEF1DA" : "#fff",
            padding: "12px",
            gap: "8px",
            borderBottom: "1px solid #ddd",
            cursor: "pointer",
            transition: "background-color 0.3s ease-in-out",
            "&:hover": {
              backgroundColor: "#EAEAEA",
            },
          }}
          onClick={() => handleMenuItemClick(item, type)}
        >
          <Typography variant="body1" fontWeight={600}>
            {item?.resType}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {item?.startDateWithTime} {item?.duration && `- ${item?.duration}`}
          </Typography>
          {item?.guests && (
            <Typography variant="body2" color="textSecondary">
              Guests:{" "}
              {item?.guests?.length > 0
                ? item?.guests.map((guest) => guest?.name).join(", ")
                : "No guests"}
            </Typography>
          )}

          {/* Show Accordion for Ticket/Activity */}
          {(type === "ticket" || type === "activity") && (
            <Accordion
              expanded={expandedId === item.id}
              sx={{ width: "100%", mt: 1, boxShadow: "none" }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>{label}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <img
                    src={qrcode}
                    alt="QR Code"
                    width="120px"
                    height="120px"
                  />
                  <Typography variant="body2" mt={1}>
                    Booking ID: {item?.id}
                  </Typography>
                  <Typography variant="body2">
                    Reservation Type: {item?.resType}
                  </Typography>
                  <Typography variant="body2">
                    Time: {item?.startDateWithTime}
                  </Typography>
                </Box>
              </AccordionDetails>
            </Accordion>
          )}
        </Box>
      ))}
    </>
  );
};

export default ReservationSelectComponent;
